import { useState } from 'react';
import { useRefreshToken } from '../../hooks';
import { useTheme } from '@mui/material';

import {
  CssBaseline,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  Badge,
  Box,
} from '@mui/material';
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Mail as MailIcon,
  Notifications as NotificationsIcon,
} from '@mui/icons-material';

import { logoutListItems, mainListItems } from './NavigationItems';
import {
  DrawerHeader,
  Drawer,
  AppBar,
} from '../../components/DashboardComponents';
import agrowelogo from '../../assets/pictures/agrowelogo.png';
import colors from '../../assets/colors';

export default function Dashboard(props) {
  const [open, setOpen] = useState(false);
  const theme = useTheme();

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  useRefreshToken();

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar sx={{ paddingRight: 24 }}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            sx={{ marginRight: 5, ...(open && { display: 'none' }) }}
            size="large"
          >
            <ChevronRightIcon />
          </IconButton>
          <img src={agrowelogo} alt="logo" height={'50vh'} />
          <Box
            sx={{
              marginLeft: 'auto',
              display: 'none',
              [theme.breakpoints.up('md')]: {
                display: 'flex',
              },
              alignContent: 'right',
              justifyContent: 'right',
            }}
          >
            <IconButton
              aria-label="show 4 new mails"
              color="inherit"
              size="large"
            >
              <Badge color="secondary">
                <MailIcon />
              </Badge>
            </IconButton>
            <IconButton
              aria-label="show 17 new notifications"
              color="inherit"
              size="large"
            >
              <Badge color="secondary">
                <NotificationsIcon />
              </Badge>
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <Typography
            variant="h6"
            align="left"
            sx={{ marginRight: 12, color: colors.white }}
          >
            Witaj !
          </Typography>
          <IconButton
            color="inherit"
            aria-label="close drawer"
            onClick={handleDrawerClose}
            size="large"
          >
            <ChevronLeftIcon
              sx={{
                '& .MuiIcon-colorPrimary': {
                  backgroundColor: colors.white,
                },
              }}
            />
          </IconButton>
        </DrawerHeader>
        <List>{mainListItems}</List>
        <Divider sx={{ backgroundColor: colors.white }} />
        <List>{logoutListItems}</List>
      </Drawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
          py: theme.spacing(2),
          px: theme.spacing(4),
        }}
        id="dashboard_main"
      >
        {props.content && <props.content />}
      </Box>
    </Box>
  );
}
